import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import MasonryLayout from "./MasonryLayout";
import Spinner from "./Spinner";
import NotFound from "../assets/notFound.png";
import { searchQuery, feedQuery } from "../utils/data";
import {client} from '../client'

const Feed = () => {
  const [loading, setLoading] = useState(false);
  const [posts, setPosts] = useState(null);

  const {categoryId} = useParams();

  useEffect(() => {
    setLoading(true);
    if(categoryId){
      const query = searchQuery(categoryId);
      client.fetch(query).then(data => {
        setPosts(data);
        setLoading(false);
      });
    }else{
      client.fetch(feedQuery).then(data => {
        setPosts(data);
        setLoading(false);
      })
    }
  }, [categoryId])
  
  if (loading) return <Spinner msg={'New Feeds are loading'}/>

  if(!posts?.length) return(
    <div className="w-full h-screen flex flex-col justify-center items-center">
      <p>Sorry 🙁 no post available</p>
      <img src={NotFound} alt="notfound" className="md:w-[30%] w-[80%] mt-5" />
    </div>
  );

  return <div>
    { posts && <MasonryLayout posts={posts}/>}
  </div>

};

export default Feed;